import { Select } from 'antd';

import utils from './utils';


const PeriodSelect = ({ value = [], onChange, disabled = false }) => {

    const handleChange = (newTags) => {
        onChange?.(newTags);
    };

    return (
       <Select
          showSearch
          disabled={disabled}
          style={{ minWidth: 200, flex: 1 }}
          placeholder=""
          optionFilterProp="label"
          options={utils.REPEAT_PERIOD_OPTIONS}
          value={value}
          onChange={handleChange}
        />
    );
}

export default PeriodSelect;
